import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';

type Kind =
  | 'muted'
  | 'mint'
  | 'mint-underline'
  | 'underline'
  | 'uppercase'
  | 'underline-uppercase'
  | 'mint-uppercase'
  | 'hover-underline'
  | 'dark-blue';

const useStyles = makeStyles(theme => ({
  noOutline: {
    '&:focus': {
      outline: 'none',
    },
  },
  link: {
    fontFamily: theme.typography.fontFamily,
    textDecoration: 'none',
  },
  'kind-dark-blue': {
    color: theme.palette.grey[700],
  },
  'kind-muted': {
    color: theme.palette.grey[50],
    fill: theme.palette.grey[50],
    stroke: theme.palette.grey[50],
  },
  'kind-mint-underline': {
    textDecoration: 'underline',
    color: theme.palette.secondary.main,
  },
  'kind-mint-uppercase': {
    textTransform: 'uppercase',
    color: theme.palette.secondary.main,
  },
  'kind-mint': {
    color: theme.palette.secondary.main,
  },
  'kind-underline': {
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  'kind-uppercase': {
    textTransform: 'uppercase',
  },
  'kind-underline-uppercase': {
    textDecoration: 'underline',
    textTransform: 'uppercase',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  'kind-hover-underline': {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
  children: React.ReactNode;
  className?: string;
  kind?: Kind;
  disableOutline?: boolean;
}

const Link = React.forwardRef<HTMLAnchorElement, Props>(
  ({ to, children, className, kind, disableOutline, ...rest }, ref) => {
    const classes = useStyles();

    return (
      <a
        ref={ref}
        href={to}
        className={cx(className, classes.link, {
          [classes[`kind-${kind}`]]: Boolean(kind),
          [classes.noOutline]: disableOutline,
        })}
        {...rest}
      >
        {children}
      </a>
    );
  },
);

export default Link;
